import React, { useState } from 'react'
import './Articles.scss'
import {
  Card,
  CardBody,
  CardLink,
  CardSubtitle,
  CardText,
  CardTitle,
  Col,
  Container,
  Row,
} from 'reactstrap'

function Articles() {
  const [isMobile, setIsMobile] = useState(false)

  window.addEventListener('resize', () => {
    setIsMobile(window.innerWidth < 768)
  }, false);

  return (
    <Container fluid className="Articles pb-5">
      <h1 className="h1 mb-5 text-center">Published Articles</h1>
      <Card className="mx-auto" style={{maxWidth: '800px'}}>
        <CardBody>
          <CardTitle tag={isMobile ? "h5" : "h3"} className="text-center mb-4">
            Going to the Poorhouse; Dorothea Dix in the Adirondacks
          </CardTitle>
          <CardSubtitle className="text-center mb-3">
            Published in Adirondack Almanac Feb 25,2021 issue.
          </CardSubtitle>
          <Row xs="12" className="align-items-center">
            <Col xs="12" md="4">
              <img className="img-fluid rounded" src="/images/dorothea-dix.jpg"  alt="Dorothea Dix"
              />
            </Col>
            <Col xs="12" md="8" className="mt-3 mt-md-0">
              <CardText tag="h5">Read about the Adirondack poorhouses as described by Dorothea Dix in her 1843 survey of New York State County farms</CardText>
            </Col>
          </Row>
          <Container className="text-center mt-3">
            <CardLink target="_blank" rel="noopener noreferrer" href="https://www.adirondackalmanack.com/2021/02/going-to-the-poorhouse-dorothea-dix-in-the-adirondacks.html">
              Read At AdirondackAlmanack
            </CardLink>
          </Container>
        </CardBody>
      </Card>
    </Container>
  )
}

export default Articles
